<mat-card appearance="outlined" (click)="cardClicked($event)" [ngClass]="{'selected' : selected}" class="d-flex flex-column">
    <mat-card-content class="d-flex align-content-center">
        <!-- Row -->
        <!-- column -->
        <div class="mr-2">
            <button mat-fab mat-card-icon class="shadow-none bg-inverse  bg-success">
                <mat-icon>{{icon}}</mat-icon>
            </button>
        </div>
        <!-- column -->
        <div class="d-flex flex-column">
            <h3 class="m-0">{{title}}</h3>
            <h6 class="text-muted m-0">{{subTitle}}</h6>
        </div>

    </mat-card-content>
</mat-card>